import React from 'react';
import { StyledRow } from "../styles/Row"
import { StyledColumn } from "../styles/Column"

export const Row = ({ children, margin }: { children?: React.ReactNode, margin?: string }) => {
    return (
      <StyledRow margin={margin}>
        {children}
      </StyledRow>
    )
}

export  const Column = ({ children, width }: { children?: React.ReactNode, width?: string }) => {
    return (
      <StyledColumn width={width}>
        {children}
      </StyledColumn>
    )
}

